import React, { Fragment } from "react";
import { useAlert } from "react-alert";

export const alerts = (Component: any) => {
	return (props: any) => {
		const alert = useAlert();

		return <Component alert={alert} {...props} />;
	};
};

// const Alerts = () => {
//     const alert = useAlert();
//     return (
//         <Fragment>
//             <button
//                 onClick={() => {
//                     alert.show("Oh look, an alert!");
//                 }}
//             >
//                 Show Alert
//       </button>
//             <button
//                 onClick={() => {
//                     alert.error("You just broke something!");
//                 }}
//             >
//                 Oops, an error
//       </button>
//             <button
//                 onClick={() => {
//                     alert.success("It's ok now!");
//                 }}
//             >
//                 Success!
//       </button>
//         </Fragment>
//     );
// };

// export default Alerts;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/Alerts.js